import { matchRoutes } from 'react-router-dom';

import { atomWithSessionStorage } from './utils/atomWithSessionStorage';

const routes = [
  { path: '/entity/:entityId' },
  { path: '/entity/:entityId/afr' },
  { path: '/entity/:entityId/code-check' },
  { path: '/entity/:entityId/comp-study' },
  { path: '/entity/:entityId/settings' },
];

export const entityAtom = atomWithSessionStorage<string>(
  'persist:entityId',
  '',
);
entityAtom.onMount = (setAtom) => {
  setAtom((prev: string) => {
    // try to read from route on mount; return original if not found
    const routeMatches = matchRoutes(routes, location);
    if (!routeMatches) return prev;
    // use the entityId from the segment
    const [first] = routeMatches;
    return first?.params?.entityId ?? '';
  });
};
